/* eslint-disable no-console */
import React from 'react'
import { createRoot } from 'react-dom/client'

import { mainApi } from '@shared/api'
import { IS_LOCAL_ENV } from '@shared/config'

import App from './app'

const rootElement = document.getElementById('root')

const root = createRoot(
  rootElement,
  !IS_LOCAL_ENV
    ? {
        onUncaughtError: (error, errorInfo) => {
          mainApi.sendErrorFeedback('onUncaughtError', {
            message: error?.message,
            stack: errorInfo?.componentStack || 'No stack trace',
          })
        },
        onCaughtError: (error, errorInfo) => {
          console.error(
            'Caught Error - errorBoundary',
            errorInfo?.errorBoundary
          )

          mainApi.sendErrorFeedback('onCaughtError', {
            message: error?.message,
            stack: errorInfo?.componentStack || 'No stack trace',
          })
        },
      }
    : {}
)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
